"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const React = __importStar(require("react"));
const components_1 = require("@smapiot/components");
const Notifications_1 = require("./Notifications");
const Header_1 = require("./Header");
const Footer_1 = require("./Footer");
const Trackers_1 = require("./Trackers");
const Layout = ({ children }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Header_1.Header, null),
        React.createElement("div", { className: "content" },
            React.createElement(components_1.Boundary, { ShowError: components_1.StandardError },
                React.createElement(React.Suspense, { fallback: React.createElement(components_1.Spinner, null) }, children)),
            React.createElement(components_1.CookieConsent, null)),
        React.createElement(Trackers_1.Trackers, null),
        React.createElement(Notifications_1.Notifications, null),
        React.createElement(Footer_1.Footer, null)));
};
exports.Layout = Layout;
